import AxiosInstance from "../axiosInstance"; 

export const getCityList = async (stateId) => {
  const storageKey = `${stateId}_city`;
  const cached = localStorage.getItem(storageKey);

  if (cached) {
    try {
      const stored = JSON.parse(cached);
      if (stored.length > 0) return stored;
    } catch (e) {
      console.error("Failed to parse cached cities:", e);
    }
  }

  try {
    const queryParams = new URLSearchParams({ state_id: stateId });
    const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_CITY}?${queryParams}`;
    const response = await AxiosInstance.get(url);
    const data = response?.data?.data || [];

    // ✅ Sort cities alphabetically by 'name'
    const sortedData = [...data].sort((a, b) => a.name.localeCompare(b.name));
console.log('count',sortedData.length);
    localStorage.setItem(storageKey, JSON.stringify(sortedData));
    return sortedData;
  } catch (error) {
    console.error("Error fetching cities:", error.message);
    return [];
  }
};
